module.exports = __webpack_public_path__ + "img/logo_v2.db3d69cd.png";